module.exports = __webpack_public_path__ + "img/icon_no_bg.0a41ecbe.png";